export default {
  metadata: {
    version: '1.0.0',
    id: 'tab-1.0.0',
    name: 'JDSTabBar'
  },
  hierarchy: {
    container: [
      {
        'tab-container': ['jds_tab_item']
      },
      {
        'indicator-container': [
          {
            'outer-container': ['inner-container']
          }
        ]
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{t_0}',
      'justify-content': '{t_3}',
      'align-items': '{t_4}',
      width: '{t_1}'
    },
    'indicator-container': {
      'z-index': 1,
      show: true,
      width: '{t_2}'
    },
    'tab-container': {
      width: '{t_5}',
      opacity: '{t_6}',
      'background-color': '{t_7}',
      'align-items': '{t_8}',
      'justify-content': '{t_9}',
      gap: '{t_10}',
      'flex-direction': '{t_11}'
    },
    jds_tab_item: {
      kind: 'label_icon',
      appearance: 'normal'
    },
    'outer-container': {
      'flex-direction': '{t_12}',
      'justify-content': '{t_13}',
      'align-items': '{t_14}',
      width: '{t_15}',
      transition: {
        property: ['padding-left'],
        duration: '{rapid}',
        'timing-function': '{easeRapid}'
      }
    },
    'inner-container': {
      'background-color': '{t_17}',
      'border-radius': '{t_16}',
      height: '{t_18}',
      show: true,
      transition: {
        property: ['width'],
        duration: '{rapid}',
        'timing-function': '{easeRapid}'
      }
    }
  },
  variant: {
    overflow: {
      fit: {
        'tab-container': {
          width: '{t_19}',
          'justify-content': '{t_20}'
        },
        jds_tab_item: {
          flex: 1
        }
      }
    },
    kind: {
      label: {
        jds_tab_item: {
          kind: 'label'
        }
      },
      icon: {
        jds_tab_item: {
          kind: 'icon'
        }
      }
    },
    appearance: {
      tab_bar: {
        'tab-container': {
          'background-color': '{t_21}',
          'padding-right': '{t_22}',
          'padding-left': '{t_23}'
        },
        jds_tab_item: {
          appearance: 'tab_bar'
        },
        'inner-container': {
          mode: 'dark',
          'background-color': '{t_24}'
        }
      }
    }
  },
  combination: [
    {
      mobile: {
        tab_bar: {
          'indicator-container': {
            'padding-right': '{t_25}',
            'padding-left': '{t_26}'
          },
          'tab-container': {
            'padding-right': '{t_25}',
            'padding-left': '{t_26}'
          }
        }
      }
    }
  ],
  combination_config: [['_platform', 'appearance']],
  api: {
    config: {
      overflow: {
        values: ['scroll', 'fit']
      },
      kind: {
        type: 'JDSTabItem.kind',
        values: ['label_icon', 'label', 'icon']
      },
      appearance: {
        type: 'JDSTabItem.appearance',
        values: ['normal', 'tab_bar']
      },
      _platform: {
        values: ['desktop', 'mobile']
      }
    },
    data: {
      'tab-container': {
        value: {
          type: 'list',
          name: 'items',
          object: {
            label: 'string',
            icon: 'icon',
            disabled: 'boolean'
          }
        }
      },
      'outer-container': {
        'padding-left': {
          type: 'size',
          name: '_left'
        }
      },
      'inner-container': {
        width: {
          type: 'size',
          name: '_width'
        }
      },
      jds_tab_item: {
        activeTab: {
          type: 'number',
          name: 'activeTab'
        },
        label: {
          type: 'string',
          name: 'items.label'
        },
        icon: {
          type: 'icon',
          name: 'items.icon'
        },
        disabled: {
          type: 'boolean',
          name: 'items.disabled'
        }
      }
    },
    events: {
      jds_tab_item: {
        onAppear: {
          name: '_onAppear',
          platform: 'ios, android'
        },
        onClick: 'onChange'
      },
      container: {
        onScroll: {
          name: 'onScroll',
          platform: 'web'
        },
        onAppear: {
          name: '_onTabAppear',
          platform: 'ios'
        }
      }
    },
    a11y: {
      'tab-container': {
        properties: {
          role: {
            value: 'tablist'
          }
        },
        name: 'items',
        repeating: {
          ariaLabel: 'tabAriaLabel',
          ariaDescribedby: {
            name: 'tabAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_tab_item: {
        properties: {
          ariaLabel: 'items.tabAriaLabel',
          ariaDescribedby: 'items.tabAriaDescribedby'
        }
      }
    }
  }
};
